var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-icon',_vm._b({attrs:{"ios":_vm.ios,"aurora":_vm.aurora,"md":_vm.md}},'f7-icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }